import { useSyncExternalStore } from "react";

// The top bar's search box (Header.js), shared with whatever it narrows down: on a dashboard
// (OverviewShellV2.jsx) the My Services and Quick Access tiles, everywhere else the sidebar's own
// items (SideNav.jsx). One tiny store instead of a context so Header and the page body -- which
// sit in different branches of the layout -- read the same text without a provider around both.
let query = "";
let dashboardShown = 0;
const listeners = new Set();
const notify = () => listeners.forEach((listener) => listener());
const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setShellSearch = (value) => {
  query = value;
  notify();
};

export const useShellSearch = () => useSyncExternalStore(subscribe, () => query);

// A dashboard on screen: the search narrows its tiles, so the sidebar is left alone.
export const useDashboardShown = () => useSyncExternalStore(subscribe, () => dashboardShown > 0);
export const markDashboardShown = () => {
  dashboardShown += 1;
  notify();
  return () => {
    dashboardShown -= 1;
    notify();
  };
};

// Every word typed must appear in one of the texts (case-insensitive); empty search matches all.
export const matchesShellSearch = (search, ...texts) => {
  const words = (search || "").toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return true;
  const haystack = texts.filter(Boolean).join(" ").toLowerCase();
  return words.every((word) => haystack.includes(word));
};
